import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = {
  key: 1,
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-5"
}
const _hoisted_5 = {
  key: 0,
  cols: "auto",
  class: "text-left"
}
const _hoisted_6 = {
  key: 1,
  style: {"border-left":"1px solid #dddddd"},
  class: "text-left"
}
const _hoisted_7 = {
  key: 2,
  style: {"border-left":"1px solid #dddddd","width":"100px"},
  class: "text-right"
}
const _hoisted_8 = {
  key: 3,
  style: {"border-left":"1px solid #dddddd","width":"100px"},
  class: "text-right"
}
const _hoisted_9 = {
  key: 4,
  class: "text-right",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_10 = {
  key: 5,
  class: "text-right",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_11 = {
  key: 6,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_12 = {
  key: 7,
  class: "text-right",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_13 = {
  key: 8,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right py-2;"
}
const _hoisted_14 = {
  key: 9,
  class: "text-right",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_15 = {
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-center"
}
const _hoisted_16 = {
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-center"
}
const _hoisted_17 = {
  colspan: "100%",
  style: {"height":"120px","padding-top":"0","margin-top":"0"}
}
const _hoisted_18 = { style: {"font-weight":"bold"} }
const _hoisted_19 = {
  key: 0,
  style: {"text-align":"right"}
}
const _hoisted_20 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_21 = { style: {"text-align":"right"} }
const _hoisted_22 = { style: {"text-align":"right"} }
const _hoisted_23 = {
  key: 2,
  style: {"text-align":"right"}
}
const _hoisted_24 = {
  key: 3,
  style: {"text-align":"right"}
}
const _hoisted_25 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-5"
}
const _hoisted_26 = { "no-gutters": "" }
const _hoisted_27 = { class: "text-uppercase pb-1" }
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-5"
}
const _hoisted_30 = { "no-gutters": "" }
const _hoisted_31 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-5"
}
const _hoisted_32 = { "no-gutters": "" }
const _hoisted_33 = {
  style: {"background-color":"white","border-radius":"25px"},
  class: "pa-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_AccountingItemEdition2 = _resolveComponent("AccountingItemEdition2")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => _cache[38] || (_cache[38] = [
                      _createElementVNode("h2", null, "Variation des capitaux propres", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Message"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-chat",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod ||
                            _ctx.validated ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod ||
                            (_ctx.N_1AccountingPeriod &&
                                _ctx.N_1AccountingPeriod.id &&
                                !_ctx.N_1AccountingPeriod.closed)
                        ,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.validateCapitalChanges()), ["stop"])),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod ||
                            (_ctx.N_1AccountingPeriod &&
                                _ctx.N_1AccountingPeriod.id &&
                                !_ctx.N_1AccountingPeriod.closed)
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[40] || (_cache[40] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_btn, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.validateCapitalChanges('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_btn_icon, {
                          size: "small",
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.validateCapitalChanges('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[41] || (_cache[41] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[43] || (_cache[43] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px","color":"'{{secondary}}'"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true)),
                            title: `Afficher l'activité`
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[42] || (_cache[42] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.acrId && _ctx.accountingPeriod && !_ctx.accountingPeriod.closed)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAuditCheckResults())),
                                title: `Supprimer les commentaires et les validations`
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "$oss-trash" })
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                class: "d-flex align-center",
                                disabled: "",
                                title: `Supprimer les commentaires et les validations`
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    size: "small",
                                    icon: "$oss-trash"
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large",
                    icon: "$oss-warning"
                  }),
                  _cache[44] || (_cache[44] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (
                    _ctx.N_1AccountingPeriod && _ctx.N_1AccountingPeriod.id && !_ctx.N_1AccountingPeriod.closed
                )
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  "no-gutters": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "d-flex justify-center mb-3"
                    }, {
                      default: _withCtx(() => _cache[45] || (_cache[45] = [
                        _createElementVNode("h3", null, " N-1 n'est pas clôturé : Mon dossier - Exercices - N-1 - Modifier - Clôturer - Calculer les reports à nouveau ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_ctx.accountingPeriod && _ctx.accountingPeriod.closed)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": "",
                        class: "d-flex flex-column justify-center align-center mb-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            class: "mr-2 mb-1",
                            size: "large",
                            icon: "$oss-warning"
                          }),
                          _cache[46] || (_cache[46] = _createElementVNode("h3", null, "Période clôturée", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.N_1AccountingPeriod || !_ctx.N_1AccountingPeriod.id)
                    ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                        key: 1,
                        class: "py-2 px-4"
                      }, {
                        default: _withCtx(() => _cache[47] || (_cache[47] = [
                          _createElementVNode("h3", { class: "yellow_custom--text" }, "Premier exercice : pas de N-1", -1)
                        ])),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 2,
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.noData)
                            ? (_openBlock(), _createBlock(_component_v_card_title, {
                                key: 0,
                                style: {"color":"#78c5c2"},
                                class: "py-2 px-0"
                              }, {
                                default: _withCtx(() => _cache[48] || (_cache[48] = [
                                  _createElementVNode("h4", null, "Aucune écriture enregistrée", -1)
                                ])),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "px-4 d-flex align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "11",
                                      class: "title font-weight-bold"
                                    }, {
                                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                                        _createTextVNode(" Éléments d'analyse ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_col, {
                                      cols: "1",
                                      class: "d-flex align-center justify-center pr-5"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.validated)
                                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                                      key: 0,
                                                      color: "primary",
                                                      size: "large",
                                                      icon: "$check_circle"
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "6",
                                              class: "d-flex align-center"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_btn_icon, {
                                                  icon: 
                                                _ctx.showTable ? '$fa-chevron-up' : '$fa-chevron-down'
                                            ,
                                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showTable = !_ctx.showTable))
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expand_transition, null, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", null, [
                                      _createVNode(_component_v_card_text, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_data_table, {
                                            expanded: _ctx.expanded,
                                            "onUpdate:expanded": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.expanded) = $event)),
                                            headers: _ctx.capitalAccountableAccountsHeaders,
                                            items: _ctx.groupedAccountableAccounts,
                                            "item-value": "groupName",
                                            loading: _ctx.loading,
                                            class: "table",
                                            style: {"border":"1px #ededed solid"},
                                            "items-per-page": -1
                                          }, {
                                            "no-data": _withCtx(() => _cache[50] || (_cache[50] = [
                                              _createTextVNode("Aucune charge à réintégrer")
                                            ])),
                                            item: _withCtx((props) => [
                                              _createElementVNode("tr", null, [
                                                (props.item.groupName)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(props.item.groupName), 1))
                                                  : _createCommentVNode("", true),
                                                (props.item.groupDescription)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(props.item.groupDescription), 1))
                                                  : _createCommentVNode("", true),
                                                (props.item.carryForward)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.carryForward,
                                                            { currency: "", DC: true },
                                                        )), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_8, " - ")),
                                                (props.item.increases)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.increases,
                                                            undefined,
                                                        )), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_10, " - ")),
                                                (props.item.decreases)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.decreases,
                                                            undefined,
                                                        )), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_12, " - ")),
                                                (props.item.balance)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            props.item.balance,
                                                            { currency: "", DC: true },
                                                        )), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_14, " - ")),
                                                _createElementVNode("td", _hoisted_15, [
                                                  (
                                                            _ctx.accountingPeriod &&
                                                            _ctx.accountingPeriod.closed
                                                        )
                                                    ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                        key: 0,
                                                        icon: "\n                                                            $add_circle_outline\n                                                        ",
                                                        disabled: ""
                                                      }))
                                                    : (props.item.comment)
                                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                          key: 1,
                                                          icon: "$create",
                                                          onClick: ($event: any) => (_ctx.expandComment(props.item)),
                                                          color: "primary"
                                                        }, null, 8, ["onClick"]))
                                                      : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                          key: 2,
                                                          icon: "\n                                                            $add_circle_outline\n                                                        ",
                                                          onClick: ($event: any) => (_ctx.expandComment(props.item))
                                                        }, null, 8, ["onClick"]))
                                                ]),
                                                _createElementVNode("td", _hoisted_16, [
                                                  (
                                                            _ctx.disabledDetailsValidateBtn(props.item)
                                                        )
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        rounded: "",
                                                        elevation: "0",
                                                        disabled: "",
                                                        "data-cy": 
                                                            'CheckCapitalChanges-' +
                                                            props.item.groupName
                                                        ,
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[51] || (_cache[51] = [
                                                          _createTextVNode(" Valider ")
                                                        ])),
                                                        _: 2
                                                      }, 1032, ["data-cy"]))
                                                    : (!props.item.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: ($event: any) => (
                                                            props.item.validated =
                                                                !props.item.validated
                                                        ),
                                                          "data-cy": 
                                                            'CheckCapitalChanges-' +
                                                            props.item.groupName
                                                        ,
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                                                            _createTextVNode(" Valider ")
                                                          ])),
                                                          _: 2
                                                        }, 1032, ["onClick", "data-cy"]))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 2,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: ($event: any) => (
                                                            props.item.validated =
                                                                !props.item.validated
                                                        ),
                                                          "data-cy": 
                                                            'CheckCapitalChanges-' +
                                                            props.item.groupName
                                                        ,
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[53] || (_cache[53] = [
                                                            _createTextVNode(" Invalider ")
                                                          ])),
                                                          _: 2
                                                        }, 1032, ["onClick", "data-cy"]))
                                                ])
                                              ])
                                            ]),
                                            "expanded-row": _withCtx(({ columns, item }) => [
                                              _createElementVNode("td", _hoisted_17, [
                                                _createVNode(_component_v_textarea, {
                                                  outlined: "",
                                                  dense: "",
                                                  modelValue: item.comment,
                                                  "onUpdate:modelValue": [($event: any) => ((item.comment) = $event), ($event: any) => (_ctx.addComment(item))],
                                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                                  style: {"margin-right":"auto","margin-left":"auto","padding":"10px","border":"1px #ededed solid"},
                                                  label: "Commentaire",
                                                  "data-cy": "CheckCapitalChanges-commentaires"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                              ])
                                            ]),
                                            "body.append": _withCtx(() => [
                                              _createElementVNode("tr", _hoisted_18, [
                                                _cache[54] || (_cache[54] = _createElementVNode("th", null, null, -1)),
                                                _cache[55] || (_cache[55] = _createElementVNode("th", null, "Totaux", -1)),
                                                (_ctx.sumsTable('carryForward'))
                                                  ? (_openBlock(), _createElementBlock("th", _hoisted_19, [
                                                      _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsTable("carryForward"),
                                                                { currency: "", DC: true },
                                                            )), 1)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("th", _hoisted_20, [
                                                      _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsTable("carryForward"),
                                                                undefined,
                                                            )), 1)
                                                    ])),
                                                _createElementVNode("th", _hoisted_21, [
                                                  _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsTable("increases"),
                                                                undefined,
                                                            )), 1)
                                                ]),
                                                _createElementVNode("th", _hoisted_22, [
                                                  _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsTable("decreases"),
                                                                undefined,
                                                            )), 1)
                                                ]),
                                                (_ctx.sumsTable('balance'))
                                                  ? (_openBlock(), _createElementBlock("th", _hoisted_23, [
                                                      _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsTable("balance"),
                                                                { currency: "", DC: true },
                                                            )), 1)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("th", _hoisted_24, [
                                                      _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.sumsTable("balance"),
                                                                undefined,
                                                            )), 1)
                                                    ])),
                                                _cache[56] || (_cache[56] = _createElementVNode("th", null, null, -1)),
                                                _cache[57] || (_cache[57] = _createElementVNode("th", null, null, -1))
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["expanded", "headers", "items", "loading"]),
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_spacer),
                                              _createVNode(_component_v_col, {
                                                cols: "auto",
                                                class: "pt-6"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_row, { class: "text-right" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, {
                                                        cols: "auto",
                                                        class: "text-right"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.closedPeriod || _ctx.validated)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                rounded: "",
                                                                disabled: "",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[58] || (_cache[58] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 1,
                                                                rounded: "",
                                                                elevation: "0",
                                                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateCapitalChanges())),
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                                  _createTextVNode(" Enregistrer ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_col, {
                                                        cols: "auto",
                                                        class: "text-right"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_ctx.closedPeriod)
                                                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                key: 0,
                                                                rounded: "",
                                                                elevation: "0",
                                                                disabled: "",
                                                                size: "small"
                                                              }, {
                                                                default: _withCtx(() => _cache[60] || (_cache[60] = [
                                                                  _createTextVNode(" Valider ")
                                                                ])),
                                                                _: 1
                                                              }))
                                                            : (!_ctx.validated)
                                                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 1,
                                                                  rounded: "",
                                                                  elevation: "0",
                                                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validateAll())),
                                                                  size: "small"
                                                                }, {
                                                                  default: _withCtx(() => _cache[61] || (_cache[61] = [
                                                                    _createTextVNode(" Valider ")
                                                                  ])),
                                                                  _: 1
                                                                }))
                                                              : (_openBlock(), _createBlock(_component_v_btn, {
                                                                  key: 2,
                                                                  rounded: "",
                                                                  elevation: "0",
                                                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.unvalidateAll())),
                                                                  "data-cy": "CheckCapitalChanges-unValid",
                                                                  size: "small"
                                                                }, {
                                                                  default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                                    _createTextVNode(" Invalider ")
                                                                  ])),
                                                                  _: 1
                                                                }))
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ], 512), [
                                      [_vShow, _ctx.showTable]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                        ]),
                        _: 1
                      })),
                  (!_ctx.noData)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 3,
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "px-4 d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "11",
                                  class: "title font-weight-bold"
                                }, {
                                  default: _withCtx(() => _cache[63] || (_cache[63] = [
                                    _createTextVNode(" Synthèse ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center"
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: 
                                                _ctx.showComments ? '$fa-chevron-up' : '$fa-chevron-down'
                                            ,
                                              onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                                _ctx.createComments();
                                                _ctx.showComments = !_ctx.showComments;
                                            })
                                            }, null, 8, ["icon"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expand_transition, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", _hoisted_26, [
                                      (!_ctx.comments || !_ctx.comments.length)
                                        ? (_openBlock(), _createBlock(_component_v_card_text, {
                                            key: 0,
                                            class: "px-0"
                                          }, {
                                            default: _withCtx(() => _cache[64] || (_cache[64] = [
                                              _createTextVNode(" Aucun commentaire saisi ")
                                            ])),
                                            _: 1
                                          }))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comments, (comment, index) => {
                                            return (_openBlock(), _createBlock(_component_v_card_text, {
                                              key: index,
                                              class: "px-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("h3", _hoisted_27, _toDisplayString(comment.title), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toArray(comment.text), (commentLine, ic) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: ic,
                                                    class: "mb-0 px-0"
                                                  }, [
                                                    _createElementVNode("p", _hoisted_28, _toDisplayString(commentLine), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                    ], 512), [
                                      [_vShow, _ctx.showComments]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.loading && !_ctx.dataLoading)
                    ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                        key: 4,
                        connectedDocuments: _ctx.connectedDocuments,
                        companyId: _ctx.companyId,
                        acKey: _ctx.acKey,
                        auditCheckResult: _ctx.auditCheckResult || {},
                        accountingPeriodId: _ctx.accountingPeriodId || undefined,
                        onUnlinkedDocument: _cache[17] || (_cache[17] = ($event: any) => (_ctx.unlinkDocument($event))),
                        onShowLinkedDocument: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showLinkedDocument($event)))
                      }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                    : _createCommentVNode("", true),
                  (!_ctx.loading && !_ctx.dataLoading)
                    ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                        key: 5,
                        results: _ctx.results,
                        companyId: _ctx.companyId
                      }, null, 8, ["results", "companyId"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_card_text, { elevation: "0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "px-4 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "title font-weight-bold"
                            }, {
                              default: _withCtx(() => _cache[65] || (_cache[65] = [
                                _createTextVNode(" Commentaires détaillés ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                                _ctx.showLongComment
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            ,
                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showLongComment = !_ctx.showLongComment))
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expand_transition, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_textarea, {
                                    modelValue: _ctx.longComment,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.longComment) = $event)),
                                    disabled: _ctx.closedPeriod || _ctx.validated,
                                    "auto-grow": "",
                                    class: "pt-1",
                                    style: {"border":"1px #ededed solid"},
                                    outlined: ""
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "pt-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { class: "text-right" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "auto",
                                                class: "text-right"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.closedPeriod || _ctx.validated)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        rounded: "",
                                                        disabled: "",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[66] || (_cache[66] = [
                                                          _createTextVNode(" Enregistrer ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 1,
                                                        rounded: "",
                                                        elevation: "0",
                                                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.validateCapitalChanges())),
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                          _createTextVNode(" Enregistrer ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "auto",
                                                class: "text-right"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.closedPeriod)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        rounded: "",
                                                        elevation: "0",
                                                        disabled: "",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[68] || (_cache[68] = [
                                                          _createTextVNode(" Valider ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : (!_ctx.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.validateAll())),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                            _createTextVNode(" Valider ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 2,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.unvalidateAll())),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                            _createTextVNode(" Invalider ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 512), [
                              [_vShow, _ctx.showLongComment]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { elevation: "0" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "px-4 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "title font-weight-bold"
                            }, {
                              default: _withCtx(() => _cache[71] || (_cache[71] = [
                                _createTextVNode(" Commentaires synthétiques ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_col, {
                              cols: "1",
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center"
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "6",
                                      class: "align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: 
                                                _ctx.showShortComment
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            ,
                                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showShortComment = !_ctx.showShortComment))
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expand_transition, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_textarea, {
                                    modelValue: _ctx.shortComment,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.shortComment) = $event)),
                                    disabled: _ctx.closedPeriod || _ctx.validated,
                                    "auto-grow": "",
                                    style: {"border":"1px #ededed solid"},
                                    outlined: ""
                                  }, null, 8, ["modelValue", "disabled"]),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "pt-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { class: "text-right" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "auto",
                                                class: "text-right"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.closedPeriod || _ctx.validated)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        rounded: "",
                                                        disabled: "",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[72] || (_cache[72] = [
                                                          _createTextVNode(" Enregistrer ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 1,
                                                        rounded: "",
                                                        elevation: "0",
                                                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.validateCapitalChanges())),
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[73] || (_cache[73] = [
                                                          _createTextVNode(" Enregistrer ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "auto",
                                                class: "text-right"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.closedPeriod)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 0,
                                                        rounded: "",
                                                        elevation: "0",
                                                        disabled: "",
                                                        size: "small"
                                                      }, {
                                                        default: _withCtx(() => _cache[74] || (_cache[74] = [
                                                          _createTextVNode(" Valider ")
                                                        ])),
                                                        _: 1
                                                      }))
                                                    : (!_ctx.validated)
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.validateAll())),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[75] || (_cache[75] = [
                                                            _createTextVNode(" Valider ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 2,
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.unvalidateAll())),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[76] || (_cache[76] = [
                                                            _createTextVNode(" Invalider ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 512), [
                              [_vShow, _ctx.showShortComment]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.showGeneralLedgerCard)
                    ? (_openBlock(), _createBlock(_component_v_card_text, {
                        key: 6,
                        elevation: "0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "px-4 d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "5",
                                  class: "title font-weight-bold"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Grand livre c/" + _toDisplayString(_ctx.getTextFromStringArray(_ctx.items.accountableAccountsRoot)), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_col, {
                                  cols: "1",
                                  class: "d-flex align-center justify-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center"
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "6",
                                          class: "align-center"
                                        }, {
                                          default: _withCtx(() => [
                                            (!_ctx.noResults)
                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                  key: 0,
                                                  icon: 
                                                _ctx.generalLedgerExpand
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            ,
                                                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand))
                                                }, null, 8, ["icon"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  style: {"background-color":"white","border-radius":"25px","padding":"10px"},
                                  class: "my-5"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, { transition: "expand" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_GeneralLedger, {
                                                  ref: "generalLedger",
                                                  companyId: _ctx.companyId,
                                                  accountingPeriodId: _ctx.accountingPeriod.id,
                                                  accountableAccountFilter: 
                                                    _ctx.items.accountableAccountsRoot
                                                ,
                                                  excludedAccountableAccountFilter: 
                                                    _ctx.items.excludedAccountableAccounts || []
                                                ,
                                                  inNm1: false,
                                                  onQueryDone: _ctx.onQueryDone,
                                                  enableAuditedAccountableAccounts: true
                                                }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "excludedAccountableAccountFilter", "onQueryDone"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, {
                                                  style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                                  class: "d-flex justify-end"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    (
                                                        _ctx.accountingPeriod && _ctx.accountingPeriod.closed
                                                    )
                                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 0,
                                                          rounded: "",
                                                          disabled: "",
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[77] || (_cache[77] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_btn, {
                                                          key: 1,
                                                          rounded: "",
                                                          class: "btn btn_blue",
                                                          onClick: _cache[30] || (_cache[30] = ($event: any) => {
                                                        _ctx.validateCapitalChanges();
                                                        _ctx.miscellanousOperationData = undefined;
                                                        _ctx.miscellaneousOperationDialog = true;
                                                    }),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[78] || (_cache[78] = [
                                                            _createTextVNode(" OD ")
                                                          ])),
                                                          _: 1
                                                        }))
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, _ctx.generalLedgerExpand]
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64)),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.miscellaneousOperationDialog,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.miscellaneousOperationDialog) = $event)),
          actions: _ctx.actionsMiscellaneousOperation,
          "min-width": "90vw"
        }, {
          default: _withCtx(() => [
            (_ctx.miscellaneousOperationDialog)
              ? (_openBlock(), _createBlock(_component_AccountingItemEdition2, {
                  key: 0,
                  companyId: _ctx.companyId,
                  prefilledRows: _ctx.miscellanousOperationData,
                  acKey: _ctx.acKey,
                  actions: _ctx.actionsMiscellaneousOperation,
                  auditCheckResult: _ctx.auditCheckResult,
                  accountingPeriodId: _ctx.accountingPeriodId,
                  onUpsert: _cache[31] || (_cache[31] = ($event: any) => (_ctx.refresh()))
                }, null, 8, ["companyId", "prefilledRows", "acKey", "actions", "auditCheckResult", "accountingPeriodId"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "actions"]),
        (_ctx.displayActivityDialog)
          ? (_openBlock(), _createBlock(_component_oss_dialog, {
              key: 4,
              modelValue: _ctx.displayActivityDialog,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
              title: "Activité",
              "valid-title": "Fermer",
              onValid: _cache[34] || (_cache[34] = ($event: any) => (_ctx.displayActivityDialog = false)),
              onClose: _cache[35] || (_cache[35] = ($event: any) => (_ctx.displayActivityDialog = false)),
              "min-width": "60vw"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UsersActivitiesHistory, {
                  auditCheckKey: _ctx.acKey,
                  accountingPeriodId: _ctx.accountingPeriodId
                }, null, 8, ["auditCheckKey", "accountingPeriodId"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.openChat)
          ? (_openBlock(), _createBlock(_component_Chat, {
              key: 5,
              auditCheckAccountingPeriodKey: _ctx.chatId,
              chatTitle: 'Chat'
            }, null, 8, ["auditCheckAccountingPeriodKey"]))
          : _createCommentVNode("", true),
        (_ctx.dialogAuditCheckDocumentsManager)
          ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
              key: 6,
              modelValue: _ctx.dialogAuditCheckDocumentsManager,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
              disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
              companyId: _ctx.companyId,
              documentToDisplay: _ctx.documentToDisplay,
              connectedDocuments: _ctx.connectedDocuments || [],
              acKey: _ctx.acKey,
              auditCheckResult: _ctx.auditCheckResult || {},
              accountingPeriodId: _ctx.accountingPeriodId || undefined,
              alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
              onUpsertedAuditCheckResult: _ctx.upsertedACR,
              onResetDialogData: _cache[37] || (_cache[37] = ($event: any) => {
                    _ctx.alreadyLinkedDoc = false;
                    _ctx.documentToDisplay = {};
                })
            }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}